var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_1379_10302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5015 6.125H4.70801",
    stroke: "#828282",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9058 11.375V18.375",
    stroke: "#828282",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3037 11.375V18.375",
    stroke: "#828282",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.702 6.125V22.75C22.702 22.9821 22.6072 23.2046 22.4385 23.3687C22.2698 23.5328 22.0409 23.625 21.8023 23.625H7.40703C7.16841 23.625 6.93957 23.5328 6.77084 23.3687C6.60211 23.2046 6.50732 22.9821 6.50732 22.75V6.125",
    stroke: "#828282",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1035 6.125V4.375C19.1035 3.91087 18.9139 3.46575 18.5765 3.13756C18.239 2.80937 17.7813 2.625 17.3041 2.625H11.9059C11.4286 2.625 10.9709 2.80937 10.6335 3.13756C10.296 3.46575 10.1064 3.91087 10.1064 4.375V6.125",
    stroke: "#828282",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_10302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7906,
    height: 28,
    fill: "white",
    transform: "translate(0.209473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.2c308216d8af3e5775e7f9d9610f3d4a.svg";
export { ForwardRef as ReactComponent };